import { defaultFill } from '../utils/constants';
var muiMinusGlyph = {
    paths: [
        {
            path: 'M6.36303828,12.875 L17.6369617,12.875 C18.1034689,12.875 18.5,12.4747758 18.5,11.9960762 C18.5,11.5173767 18.1034689,11.125 17.6369617,11.125 L6.36303828,11.125 C5.91208134,11.125 5.5,11.5173767 5.5,11.9960762 C5.5,12.4747758 5.91208134,12.875 6.36303828,12.875 Z',
            fill: defaultFill,
        },
    ],
    title: 'Minus',
    width: 24,
    height: 24,
};
var muiMinus = {
    base: muiMinusGlyph,
};
export { muiMinus };
//# sourceMappingURL=minus.js.map